import React from "react"
import PropTypes from "prop-types"
import {
  CardHeader,
  CardContent,
  Button,
  CardFooter,
  CardTitle,
  CardDescription,
} from "ksc-portal-common-components/shadcn"

const success = ({ backToLogin }) => (
  <>
    <CardHeader className="flex flex-col items-center gap-4">
      <svg
        width="66"
        height="66"
        viewBox="0 0 66 66"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Illustrations">
          <circle
            id="Ellipse 85"
            cx="33"
            cy="33"
            r="32"
            fill="#D1D5DB"
            stroke="#9BA3AF"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            id="Ellipse 84"
            cx="33.0005"
            cy="33"
            r="24.96"
            fill="#F7FAFB"
            stroke="#9BA3AF"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector (Stroke)"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M45.5019 23.4659C46.1485 24.1042 46.1682 25.1593 45.5458 25.8224L29.9052 42.4891C29.5988 42.8155 29.1761 43 28.7344 43C28.2926 43 27.8699 42.8155 27.5636 42.4891L20.4542 34.9134C19.8318 34.2502 19.8515 33.1951 20.4981 32.5568C21.1447 31.9184 22.1734 31.9386 22.7958 32.6018L28.7344 38.93L43.2042 23.5109C43.8266 22.8477 44.8553 22.8275 45.5019 23.4659Z"
            fill="#0F612D"
            stroke="#0F612D"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </CardHeader>
    <CardContent className="flex flex-col items-center space-y-2">
      <CardTitle className="text-center text-2xl font-medium text-foreground">
        Successfully Updated
      </CardTitle>
      <CardDescription className="text-center text-sm text-muted-foreground">
        Your password has been updated successfully.
      </CardDescription>
    </CardContent>
    <CardFooter className="flex justify-center">
      <Button variant="outline" onClick={backToLogin} className="w-full">
        Close
      </Button>
    </CardFooter>
  </>
)

success.propTypes = {
  backToLogin: PropTypes.func.isRequired,
}

export default success
